import { api } from '@dpgradio/creative'
import { defineStore } from 'pinia'
import { useUserStore } from './user'
import { useA11yStore } from './a11y'

export const useRatingsStore = defineStore('ratings', {
  state: () => ({
    ratings: null,
    ratingsQueue: [],
  }),
  getters: {
    hasLiked() {
      return (track) => this.ratings?.includes(track.selector_code)
    },
  },
  actions: {
    async initialize() {
      const ratings = await api.ratings.allForMember().then((paginator) => paginator.fetchAllPrevious())
      this.ratings = [...ratings.map((rating) => rating.selector_code), ...this.ratingsQueue]
    },
    async toggleLike(track) {
      this.hasLiked(track) ? this.unlike(track) : this.like(track)
    },
    async like(track) {
      const a11y = useA11yStore()
      try {
        await useUserStore().requireAuthentication()
      } catch (e) {
        console.error('Authentication canceled by the user or failed:', e)
        return
      }

      if (this.ratings) {
        this.ratings.push(track.selector_code)
      } else {
        // If the ratings haven't been loaded yet, we'll queue the like
        this.ratingsQueue.push(track.selector_code)
      }

      await api.ratings.like(track.selector_code)

      a11y.announce(`Je hebt ${track.title} van ${track.artist?.name} geliket`)
    },
    async unlike(track) {
      const a11y = useA11yStore()
      try {
        await useUserStore().requireAuthentication()
      } catch (e) {
        console.error('Authentication canceled by the user or failed:', e)
        return
      }

      this.ratings = this.ratings.filter((code) => code !== track.selector_code)
      this.ratingsQueue = this.ratingsQueue.filter((code) => code !== track.selector_code)

      await api.ratings.unlike(track.selector_code)

      a11y.announce(`Je hebt ${track.title} van ${track.artist?.name} unliked`)
    },
  },
})
